import React from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import * as Styles from './_confirmReleaseEarmarkModal.module.scss';

const ConfirmReleaseEarmarkModal = () => {
    const isOpen = useAppSelector(state => state.customer.modals.confirmReleaseEarmarkModalIsOpen);
    const isLoading = useAppSelector(state => state.customer.loadings.updateReleaseEarmark);
    const error = useAppSelector(state => state.customer.errors.updateReleaseEarmark);
    const customerTransactions = useAppSelector(state => state.customer.tempReleaseEarmarkState.transactionId);

    const dispatch = useAppDispatch();

    const handleSubmitClick = () => {
        dispatch(
            combinedActions.customerUpdateReleaseEarmarkAttempt({ transactionId: customerTransactions })
        );
    };

    const handleOnModalClose = () => {
        dispatch(combinedActions.customerSetConfirmUpdateReleaseEarmarkModalIsOpen(false));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={'Confirm Release Earmark?'}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />
                <ActionButton
                    label='Confirm'
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    disabled={isLoading}
                />
            </div>

            {error && (
                <Text
                    label={error}
                    isError
                />
            )}
        </Modal>
    );
};

export default ConfirmReleaseEarmarkModal;
